import { forwardRef, memo, useCallback, useImperativeHandle, useState } from 'react'
import './PastVisitsSection.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import FlatList from 'flatlist-react'
import { EMPTY_PAST_VISITS_SECTION_TEXT, PAST_VISITS_TEXT, PATIENT_PAST_VISIT_ROUTE } from '../../../../utils/constants'
import { ChartSection } from '../chart-section/ChartSection'
import pastVisitsIcon from '../../../../images/charts/calendar-clock.png'
import { compareArray } from '../../Utils'
import { getPatientPastVisits } from '../../../../store/charts/ChartsThunk'
import { VisitCard } from '../visit-card/VisitCard'
import { setPatientPastVisits } from '../../../../store/charts/ChartsActions'

export const PastVisitsSection = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  forwardRef(({ id, patientInfo, userTimeZone, patientChartsSearchRow }, ref) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isCollapsed, setIsCollapsed] = useState(true)
    const [hasOpened, setHasOpened] = useState(false)

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const pastVisits = useSelector((state) => state.chartsReducer?.patientInfo?.[id]?.PastVisits || [], compareArray)

    const onSetIsCollapsed = useCallback(() => {
      if (isCollapsed) {
        if ((!pastVisits.length || !hasOpened) && patientInfo?.[id]?.VisitSummary?.CountPast) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(getPatientPastVisits(id))
        } else if (!hasOpened) {
          setHasOpened(true)
        }

        if ((pastVisits.length || !hasOpened) && !patientInfo?.[id]?.VisitSummary?.CountPast) {
          dispatch(setPatientPastVisits(id))
        } else if (!hasOpened) {
          setHasOpened(true)
        }
      }
      setIsCollapsed((prev) => !prev)
    }, [isCollapsed, pastVisits, patientInfo, dispatch, id])

    useImperativeHandle(ref, () => ({
      openPastVisits() {
        setIsCollapsed(false)
      },
    }))
    const onClickPastVisitArrow = useCallback(
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ({ visitId, provider }) => {
        navigate(`${PATIENT_PAST_VISIT_ROUTE}/${visitId}`, {
          state: { patientId: id, visitId, provider, search: patientChartsSearchRow },
        })
      },
      [id, navigate, patientChartsSearchRow],
    )

    return (
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      <ChartSection
        className='past-visits-section'
        title={PAST_VISITS_TEXT}
        icon={pastVisitsIcon}
        iconAltText='past-visits'
        setIsCollapsed={onSetIsCollapsed}
        isCollapsed={isCollapsed}
        userTimeZone={userTimeZone}
        emptyText={EMPTY_PAST_VISITS_SECTION_TEXT}
        isWithoutLastUpdated>
        {pastVisits?.length ?
          <FlatList
            displayGrid
            minColumnWidth='49%'
            gridGap='16px'
            list={pastVisits || []}
            renderItem={(visit, index) => (
              <VisitCard
                key={`past-visit${index}`}
                visit={visit}
                id={`past-visit${index}`}
                clickArrowAction={onClickPastVisitArrow}
                userTimeZone={userTimeZone}
                showStatus
              />
            )}
          />
        : null}
      </ChartSection>
    )
  }),
)
